import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

import type { CompetencyUserEndorsement } from 'shared-types';

interface Props {
  endorsement: Pick<CompetencyUserEndorsement, 'id'>;
  updateCompetencies: () => Promise<void>;
}

const ProfileCompetenciesEndorsementsDelete = ({
  endorsement,
  updateCompetencies
}: Props) => {
  const { messages } = useReduxState();

  const handleConfirm = async () => {
    await api.delete(`/admin/competency-endorsements/${endorsement.id}`);
    await updateCompetencies();
    return true;
  };

  return (
    <div>
      <ConfirmButton
        actionText={messages.competenciesEndorsementDelete}
        buttonIcon={'trash-alt'}
        buttonSize="header"
        buttonText={messages.competenciesEndorsementDelete}
        category="danger"
        confirmText={messages.competenciesEndorsementAreYouSureDelete}
        confirmTitle={messages.competenciesEndorsementDelete}
        onConfirm={handleConfirm}
        successMessage={messages.competenciesEndorsementDeleteSuccess}
      />
    </div>
  );
};

export default ProfileCompetenciesEndorsementsDelete;
